import { Button, DatePicker, Form, Select } from 'antd'
import {
  filterOption,
  normalizeDate,
  periodMap,
} from 'src/pages/finSystem/balanceSummary/reports/utils'
import { PERIOD_OPTIONS } from 'src/pages/finSystem/balanceSummary/reports/const'
import {
  DifferenceFilter,
  FormValue,
} from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/types'
import { resetExDifferenceList } from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/model'
import { useWalletOptions } from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/hook'

type Props = {
  filters: DifferenceFilter
  setFilters: (values: Partial<DifferenceFilter>) => void
  resetFilters: () => void
  initialValueForm: FormValue
}

export const ExDifferenceListFilter = ({
  filters,
  setFilters,
  resetFilters,
  initialValueForm,
}: Props) => {
  const { walletOptions, currencyOptions } = useWalletOptions()
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker
  const { Item } = Form

  const handleChangeForm = (valueField: Record<string, any>) => {
    const [key, value] = Object.entries(valueField)[0]

    if (key === 'period' && value === 'date_range') {
      setFilters({ dateFrom: undefined, dateTo: undefined })
      resetExDifferenceList()
      setTimeout(() => {
        form.validateFields(['periodDatePicker']).catch(() => {})
      }, 0)
      return
    }

    if (key === 'periodDatePicker') {
      const [dateFromPicker, dateToPicker] = value ?? []
      const dateFrom = normalizeDate(dateFromPicker)
      const dateTo = normalizeDate(dateToPicker)
      setFilters({ dateFrom, dateTo })
    }

    if (key === 'period') {
      form.setFieldValue('periodDatePicker', undefined)
      const { dateFrom, dateTo } = periodMap[value] ?? {}
      setFilters({ dateFrom, dateTo })
    }
  }

  const checkVisibleReset = () => {
    const keys = Object.keys(filters)
    if (keys.includes('currencies') || keys.includes('walletIds')) {
      return true
    }
    return false
  }

  const period = Form.useWatch('period', form)
  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleChangeForm}
      initialValues={initialValueForm}
    >
      <Item name="walletIds" key="walletIds" style={{ width: 230 }}>
        <Select
          placeholder="Wallets"
          mode="multiple"
          allowClear
          options={walletOptions}
          filterOption={filterOption}
          onOpenChange={() => {
            const value = form.getFieldValue('walletIds')
            setFilters({ walletIds: value })
          }}
          onDeselect={(value) => {
            const current = form.getFieldValue('walletIds')
            setFilters({ walletIds: current.filter((v: any) => v !== value) })
          }}
        />
      </Item>

      <Item name="currencies" key="currencies" style={{ width: 200 }}>
        <Select
          placeholder="Currency"
          mode="multiple"
          options={currencyOptions}
          filterOption={filterOption}
          onOpenChange={() => {
            const value = form.getFieldValue('currencies')
            setFilters({ currencies: value })
          }}
          onDeselect={(value) => {
            const current = form.getFieldValue('currencies')
            setFilters({ currencies: current.filter((v: any) => v !== value) })
          }}
        />
      </Item>

      <Item name="period" key="period" style={{ width: 150 }}>
        <Select placeholder="Period" options={PERIOD_OPTIONS} />
      </Item>

      {period === 'date_range' && (
        <Item
          name="periodDatePicker"
          key="periodDatePicker"
          rules={[
            {
              required: true,
              message: 'Required field',
            },
          ]}
        >
          <RangePicker style={{ width: 250 }} />
        </Item>
      )}
      {checkVisibleReset() && (
        <Item>
          <Button
            onClick={() => {
              form.setFieldsValue({
                currencies: undefined,
                walletIds: undefined,
              })
              resetFilters()
            }}
          >
            Reset filters
          </Button>
        </Item>
      )}
    </Form>
  )
}
